import { HttpQueryConfig } from '../../../core/model/HttpQueryConfig.model';

  // todo: handling errors in requests
export const CpeMonitoredDevicesQuery: HttpQueryConfig = {
  GetMonitoredDevices: {
    key: 'GetMonitoredDevices',
    url: '/api/customers/{customerId}/monitored-devices',
    errors: {},
  },
  GetCpuMeasurements: {
    key: 'GetCpuMeasurements',
    url: '/api/customers/{customerId}/monitored-devices/{deviceId}/cpu-measurements',
    errors: {},
  },
  GetAvailabilityMeasurements: {
    key: 'GetAvailabilityMeasurements',
    url: '/api/customers/{customerId}/monitored-devices/{deviceId}/availability-measurements',
    errors: {},
  },
};